import styled, { keyframes } from "styled-components";

import { Text } from "@similarweb/ui-components/foundations";

import { aiAgentColors } from "app/pages/sales-intelligence/modules/ai-agent/components";

const gradientAnimation = keyframes`
  0% { background-position: 30% 0%; }
  100% { background-position: -70% 0%; }
`;

export const StyledGradientText = styled(Text)`
    background: linear-gradient(
        90deg,
        ${aiAgentColors.gradient.blue} 0%,
        ${aiAgentColors.gradient.green} 15.48%,
        ${aiAgentColors.gradient.blue} 30.96%
    );
    background-size: 200% 200%;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: ${gradientAnimation} 1s ease infinite;
    text-align: center;
`;
